var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineHeartLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2969 0.4375C12.5223 0.4375 10.9685 1.20063 10 2.49055C9.03148 1.20063 7.47773 0.4375 5.70312 0.4375C4.29051 0.439092 2.9362 1.00096 1.93733 1.99983C0.938458 2.9987 0.376592 4.35301 0.375 5.76563C0.375 11.7813 9.29445 16.6505 9.6743 16.8516C9.77441 16.9054 9.88632 16.9336 10 16.9336C10.1137 16.9336 10.2256 16.9054 10.3257 16.8516C10.7055 16.6505 19.625 11.7813 19.625 5.76563C19.6234 4.35301 19.0615 2.9987 18.0627 1.99983C17.0638 1.00096 15.7095 0.439092 14.2969 0.4375ZM10 15.4594C8.43078 14.545 1.75 10.3796 1.75 5.76563C1.75136 4.71761 2.16829 3.71291 2.90935 2.97185C3.65041 2.23079 4.65511 1.81386 5.70312 1.8125C7.37461 1.8125 8.77797 2.70281 9.36406 4.13281C9.41586 4.25891 9.50397 4.36676 9.61721 4.44266C9.73044 4.51856 9.86368 4.55909 10 4.55909C10.1363 4.55909 10.2696 4.51856 10.3828 4.44266C10.496 4.36676 10.5841 4.25891 10.6359 4.13281C11.222 2.70023 12.6254 1.8125 14.2969 1.8125C15.3449 1.81386 16.3496 2.23079 17.0907 2.97185C17.8317 3.71291 18.2486 4.71761 18.25 5.76563C18.25 10.3727 11.5675 14.5441 10 15.4594Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineHeartLarge);
export default __webpack_public_path__ + "static/media/outline_heart_large.ee27550638a519df90544e680f10eac9.svg";
export { ForwardRef as ReactComponent };